import { render, staticRenderFns } from "./ProfileQuickInfoSkillsView.vue?vue&type=template&id=0b2349ce"
import script from "./ProfileQuickInfoSkillsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileQuickInfoSkillsView.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports